(ns journal-app-client.config)

(goog-define VERSION "")

(defn touch-enabled-device? []
  (or (js-in "ontouchstart" js/window)
    (> (.-maxTouchPoints js/navigator) 0)
    (> (.-msMaxTouchPoints js/navigator) 0)))

(def is-dev-env? goog.DEBUG)

(defn get-journal-app-server-url []
  "../journal-app-server")

(defn deploy-server-url []
  "http://localhost:3000/")
